import React, { useState } from 'react';
import axios from 'axios';
import {
  Box,
  Typography,
  Card,
  CardContent,
  Button,
  FormControlLabel,
  Checkbox,
  CircularProgress,
  Alert,
} from '@mui/material';
import LinkIcon from '@mui/icons-material/Link';
import { useNavigate } from 'react-router-dom';

export const HM_OWN_API_BASE = 'https://armis.rtaf.mi.th/hm';
export const HM_OWN_API_KEY = '123';
export const HM_HOME_CODE_KEY = 'hm_home_code';
export const HM_MOBILE_PHONE_KEY = 'hm_mobile_phone';

const AppConnectPage = () => {
  const navigate = useNavigate();
  const [accepted, setAccepted] = useState(false);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const username = (() => {
    try {
      const user = localStorage.getItem('user');
      if (user) {
        const parsed = JSON.parse(user);
        return parsed?.username ?? '';
      }
    } catch (err) {
      console.error('Failed to parse user from localStorage:', err);
    }
    return '';
  })();

  const handleConnect = async () => {
    if (!accepted) {
      setError('กรุณายอมรับการแชร์ข้อมูลก่อนดำเนินการ');
      return;
    }
    if (!username) {
      setError('ไม่พบชื่อผู้ใช้ กรุณาเข้าสู่ระบบใหม่');
      return;
    }
    setError(null);
    setLoading(true);
    const url = `${HM_OWN_API_BASE}/${username}/hm_own_api`;
    try {
      const { data } = await axios.post(url, { key: HM_OWN_API_KEY });
      if (data?.status == null) {
        setError('Authentication fail');
        return;
      }
      const homeCode = data?.home?.home_code ?? '';
      const mobilePhone = data?.owner?.MobilePhone ?? '';
      localStorage.setItem(HM_HOME_CODE_KEY, homeCode);
      localStorage.setItem(HM_MOBILE_PHONE_KEY, mobilePhone);
      navigate('/');
    } catch (err) {
      setError(err?.response?.data?.message || err?.message || 'Authentication fail');
    } finally {
      setLoading(false);
    }
  };

  return (
    <Box
      sx={{
        minHeight: '100vh',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        background: 'linear-gradient(120deg, rgb(175, 227, 251), rgb(241, 195, 248), rgb(250, 236, 190), rgb(185, 224, 242))',
        backgroundSize: '400% 400%',
        py: 4,
        px: 2,
      }}
    >
      <Card
        elevation={0}
        sx={{
          maxWidth: 420,
          width: '100%',
          bgcolor: 'rgba(255,255,255,0.9)',
          backdropFilter: 'blur(10px)',
          borderRadius: 3,
          boxShadow: '0 4px 20px rgba(132, 94, 194, 0.15)',
        }}
      >
        <CardContent sx={{ p: 3 }}>
          <Box sx={{ textAlign: 'center', mb: 3 }}>
            <LinkIcon sx={{ fontSize: 48, color: '#845EC2', mb: 1 }} />
            <Typography variant="h5" sx={{ fontWeight: 700, color: 'rgba(0,0,0,0.7)' }}>
              เชื่อมต่อระบบ
            </Typography>
            <Typography variant="body2" sx={{ color: 'rgba(0,0,0,0.55)', mt: 0.5 }}>
              เพื่อเชื่อมต่อระหว่างแอปพลิเคชันและแชร์ข้อมูล กรุณายอมรับเงื่อนไขด้านล่าง
            </Typography>
          </Box>

          {error && (
            <Alert severity="error" sx={{ mb: 2 }}>
              {error}
            </Alert>
          )}

          <FormControlLabel
            control={
              <Checkbox
                checked={accepted}
                onChange={(e) => setAccepted(e.target.checked)}
                sx={{ color: '#845EC2', '&.Mui-checked': { color: '#845EC2' } }}
              />
            }
            label="ยอมรับการแชร์ข้อมูลระหว่างระบบ"
            sx={{ mb: 2, display: 'block', color: 'rgba(0,0,0,0.7)' }}
          />

          <Button
            fullWidth
            variant="contained"
            onClick={handleConnect}
            disabled={loading}
            sx={{
              borderRadius: 2,
              py: 1.5,
              fontWeight: 600,
              bgcolor: '#845EC2',
              '&:hover': { bgcolor: '#6344A4' },
            }}
          >
            {loading ? <CircularProgress size={24} sx={{ color: 'white' }} /> : 'ดำเนินการเชื่อมต่อ'}
          </Button>
        </CardContent>
      </Card>
    </Box>
  );
};

export default AppConnectPage;
